import { combineReducers } from 'redux'
import formsReducer from './forms/reducers'


export default combineReducers({
	forms: formsReducer,
})
